import { render, staticRenderFns } from "./BillingAddressType.vue?vue&type=template&id=282a579e&"
import script from "./BillingAddressType.vue?vue&type=script&lang=ts&"
export * from "./BillingAddressType.vue?vue&type=script&lang=ts&"
import style0 from "./BillingAddressType.vue?vue&type=style&index=0&id=282a579e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports